<template>
    <div class="withdrawal_records">
        <div>
            <div class="choose_box">
                <div class="order_select">
                    <el-date-picker v-model="orderData" type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                </div>
                <div class="status_select">
                    <el-select v-model="recordsTypevalue" clearable placeholder="全部状态">
                        <el-option v-for="item in recordsTypeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="btn_box">
                    <el-button plain @click="handleQuery">筛选</el-button>
                </div>
            </div>
            <div class="table_box">
                <el-table :data="withdrawTableData" style="width: 100%">
                    <el-table-column prop="datetime" label="申请时间" align='left' width="170px"></el-table-column>
                    <el-table-column prop="orderno" label="申请单号" align='center' width="170px"></el-table-column>
                    <el-table-column prop="cashmoney" label="提现金额" align='center' width="150px"></el-table-column>
                    <el-table-column prop="zzfee" label="提现费用" align='center' width="150px"></el-table-column>
                    <el-table-column prop="cashaccountmoney" label="到账金额" align='center' width="150px"></el-table-column>
                    <!-- <el-table-column prop="datetime" label="申请时间" align='center'></el-table-column> -->
                    <!-- <el-table-column prop="status" label="状态" align='center'> -->
                    <el-table-column label="状态" align='center'>
                        <template slot-scope="scope">
                            <span :class="orderStatusClass(scope.row.status)">{{scope.row.statustext}}&nbsp;</span>
                            <el-tooltip placement="top">
                                <div class="tooltip_content" slot="content">提现周期一般为T+3, 提现申请后, 3个工作日<br/>后款项会自动转至对应的提现申请账户</div>
                                <!-- <span class="tooltip_span" v-if="scope.row.status == '待审核'"> -->
                                    <img class="tooltip_icon" v-if="scope.row.status == 1" :src="Icon" alt="">
                                <!-- </span> -->
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="authdesp" label="备注" align='center'></el-table-column>
                    <el-table-column label="操作" align='center'>
                        <template slot-scope="scope">
                            <el-button type="text" @click="detailsClick(scope.row.orderno)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <page :total="total" ref="page" @getList="searchClick"></page>
        </div>
    </div>
</template>

<script>
import {withdrawList} from 'api/materialMgtApi'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
export default {
    props: ['data'],
    data() {
        return {
            total: 0,
            Icon: require('@/common/images/other/icon_warning_grey@2x.png'),
            withdrawTableData: [],
            recordsTypeOption: [
                {
                    value: '',
                    label: '全部状态'
                },
                {
                    value: 0,
                    label: '已发起'
                }, {
                    value: 1,
                    label: '处理中'
                }, {
                    value: 10,
                    label: '提现完成'
                }, {
                    value: 11,
                    label: '提现失败 '
                }
            ],
            recordsTypevalue: '',
            pickerOptions2: {
                shortcuts: [
                    {
                        text: '今日',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '昨日',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24)
                            end.setTime(start.getTime() - 3600 * 1000)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            },
            orderData: ''
        }
    },
    mounted() {
        // this.getWithdrawalRecords()
    },
    methods: {
        // 获取提现记录
        getWithdrawalRecords() {
            this.setLoading(true)
            withdrawList({
                data: {
                    page: 1,
                    pageSize: 10
                },
                success: data => {
                    this.setLoading(false)
                    this.withdrawTableData = data.data
                    if (data.pageableData !== undefined) {
                        this.total = data.pageableData.rowCount
                    }
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        searchClick() {
            if (this.orderData === null) {
                this.orderData = []
            }
            this.setLoading(true)
            var params = {
                beginTime: this.orderData[0],
                endTime: this.orderData[1],
                status: this.recordsTypevalue
            }
            withdrawList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.withdrawTableData = data.data
                    if (data.pageableData !== undefined) {
                        this.total = data.pageableData.rowCount
                    }
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 获取提现列表data
        getWithdrawList() {
            this.setLoading(true)
            withdrawList({
                data: {
                    page: 1,
                    pageSize: 10
                },
                success: data => {
                    console.log('获取提现列表data:', data)
                    this.setLoading(false)
                    this.withdrawTableData = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 跳转到提现记录详情页面
        detailsClick(value) {
            this.$router.push({name: 'ShowDetails', query: {orderno: value}})
        },
        // 订单状态文字颜色:0已发起 1处理中 10提现完成 11提现失败 ,
        orderStatusClass(value) {
            if (value === 0) {
                return 'yfq'
            } else if (value === 1) {
                return 'clz'
            } else if (value === 10) {
                return 'txwc'
            } else if (value === 11) {
                return 'txsb'
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        data(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.withdrawTableData = this.data.data
                if (this.data.pageableData !== undefined) {
                    this.total = this.data.pageableData.rowCount
                }
            })
        }
    },
    computed: {
        ...mapGetters([
            'page',
            'user'
        ])
    },
    components: {
        Page
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .withdrawal_records{
        .choose_box{
            margin-top: 18px;
            height: 36px;
            display: flex;
            .order_select{
                margin-right: 20px;
                .el-input__inner {
                    width: 256px;;
                }
                .el-input__icon {
                    line-height: 30px;
                }
                .el-date-editor .el-range-separator {
                    color: #C0C4CC;
                }
                .el-date-editor .el-range-input, .el-date-editor .el-range-separator {
                    height: auto;
                }
            }
            .status_select{
                margin-right: 20px;
                .el-input__inner {
                    width: 120px;
                }
            }
            .el-input__icon {
                line-height: 0;
            }
            .el-input__inner {
                height: 36px;
                line-height: 36px;
                width: 224px;
            }
            .el-input__inner::placeholder {
                color: #303133;
            }
            .el-button,.el-button--mini {
                width: 96px;
                height: 36px;
            }
        }
        .table_box{
            margin-top: 20px;
            .el-table th>.cell {
                color: #303133;
                font-weight: bold;
                white-space: nowrap;
            }
            .red{
                color: #F56C6C;
            }
            .green{
                color: #67C23A;
            }
            td{
                .cell{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    // vertical-align: middle;
                }
                .tooltip_span{
                    width: 14px;
                    height: 14px;
                    display: inline-block;
                    // margin-top: 2px;
                    img{
                        width: 14px;
                        height: 14px;
                    }
                }
                .clz{
                    color: #E6A23C;
                }
                .txsb{
                    color: #F56C6C;
                }
                .txwc{
                    color: #67C23A;
                }
                .yfq{
                    color: #909399;
                }
                .tooltip_icon{
                    width: 16px;
                    height: 16px;
                }
            }
            td:nth-of-type(1){
                .cell{
                    justify-content: flex-start;
                }
            }
        }
        .info_box{
            margin-top: 18px;
            .info_item_box{
                margin-top: 30px;
                span:nth-of-type(1){
                    color: #203133;
                    font-weight: 500;
                }
                span:nth-of-type(2){
                    color:rgba(96,98,102,1);
                }
            }
            .info_item_box:nth-of-type(1){
                margin-top: 0px;
            }
        }
    }
</style>
<style scoped>
.tooltip_content{
    color: #606266;
    text-align: center;
    padding: 0 15px;
    line-height: 20px;
}
</style>